import { render, staticRenderFns } from "./dockFiveSixSample.vue?vue&type=template&id=2691a404&scoped=true&"
import script from "./dockFiveSixSample.vue?vue&type=script&setup=true&lang=ts&"
export * from "./dockFiveSixSample.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2691a404",
  null
  
)

export default component.exports